import React from 'react';
import { formatCurrency } from '../../../../../../../../../../utils/functions';
import './TypeStatsSection.scss';

interface TypeStats {
  name: string;
  total: number;
  count: number;
  avg_total: number;
}

interface TypeStatsSectionProps {
  typeStats: { [typeId: string]: TypeStats };
}

const TypeStatsSection: React.FC<TypeStatsSectionProps> = ({ typeStats }) => {
  if (!typeStats || Object.keys(typeStats).length === 0) {
    return null;
  }

  return (
    <div className="sb-section">
      <h4 className="sb-section-title">Estadísticas por Tipo</h4>
      {Object.values(typeStats).map((type) => (
        <div key={type.name} className="sb-row">
          <span className="sb-label">{type.name} ({type.count})</span>
          <span className="sb-value">{formatCurrency(type.total)}</span>
        </div>
      ))}
    </div>
  );
};

export default TypeStatsSection;
